import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  individualsSortName: "",
  individualsSortOrder: "",
  repaymentSortName: "",
  repaymentSortOrder: "",
};

export const sortSlice = createSlice({
  name: "sort",
  initialState,
  reducers: {
    updateSortName: (state, action) => {
      state.individualsSortName = action.payload;
    },
    updateSortOrder: (state, action) => {
      state.individualsSortOrder = action.payload;
    },
    updateSortNameRepayment: (state, action) => {
      state.repaymentSortName = action.payload;
    },
    updateSortOrderRepayment: (state, action) => {
      state.repaymentSortOrder = action.payload;
    },
  },
});

export const {
  updateSortName,
  updateSortOrder,
  updateSortNameRepayment,
  updateSortOrderRepayment,
} = sortSlice.actions;
export default sortSlice.reducer;
